import { ReactNode } from 'react';
// @mui
import { Box } from '@mui/material';
//
import { STAGE, TYPE } from '../../../theme/stage';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  tone?: 'ink' | 'ink2' | 'mute';
  opsz?: number;
};

export default function Accent({ children, tone = 'ink', opsz }: Props) {
  return (
    <Box
      component="span"
      sx={{
        ...TYPE.accent,
        color: STAGE[tone],
        ...(opsz !== undefined && { fontVariationSettings: `'SOFT' 100, 'opsz' ${opsz}` }),
      }}
    >
      {children}
    </Box>
  );
}
